// import 'core-js'
// import 'babel-polyfill'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css'
import locale from 'element-plus/lib/locale/lang/zh-cn';
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.timeout = 0 // 请求超时
document.title = '河北体育类校外培训机构综合管理平台'
// if (process.env.NODE_ENV == 'development') {
//     axios.defaults.baseURL = 'https://dev.qianhedu.com';
// } else if (process.env.NODE_ENV == 'debug') {
//     axios.defaults.baseURL = 'https://dev.qianhedu.com';
// } else if (process.env.NODE_ENV == 'production') {
//     axios.defaults.baseURL = 'https://dev.qianhedu.com';
// }


// axios.defaults.baseURL = '/api/'

const  app = createApp(App)
app.directive('title',{
    inserted:function (el){
        document.title = el.getAttribute('title')
        console.log(el)
    }
})
app.use(VueAxios, axios)
app.use(router)
app.use(ElementPlus,{locale})
app.mount('#app')

